module.exports = {"description":"","gameplay":{"description":""},"attack":{"heavy":""},"specials":{"1":{"name":"","description":""},"2":{"name":"","description":""},"3":{"name":"","description":""}},"signature":{"name":"","description":""},"author":{"name":"Kabam","type":"spotlight","profile":"https://playcontestofchampions.com/champion-spotlight-/"}}


//////////////////
// WEBPACK FOOTER
// ./src/data/guides/template.json
// module id = 557
// module chunks = 0